document.addEventListener("DOMContentLoaded", () => {

    function initInlineChat() {

        if (
            !window.gleenWidget ||
            !window.gleenWidget.initializeInlineChatWidget
        ) {
            return false;
        }

        window.gleenWidget.initializeInlineChatWidget();

        if (window.gleenWidget.hideLauncher) {
            window.gleenWidget.hideLauncher();
        }

        const observer = new MutationObserver(() => {

            // Schovat launcher
            const launcher = document.querySelector("#helix-chat-container");
            if (launcher) {
                launcher.style.display = "none";
            }

            // Zarovnat chat doprostřed
            const chat = document.querySelector("#alhena-inline-chat");

            if (chat) {

                chat.style.maxWidth = "1200px";
                chat.style.margin = "40px auto";
                chat.style.height = "80vh";
                chat.style.minHeight = "800px";
                chat.style.maxHeight = "900px";
                chat.style.overflow = "hidden";

                const root = chat.firstElementChild;

                if (root) {
                    root.style.height = "100%";
                    root.style.display = "flex";
                    root.style.flexDirection = "column";
                }

                // Najít největší vnitřní kontejner
                const divs = chat.querySelectorAll("div");

                let biggest = null;
                let area = 0;

                divs.forEach(div => {

                    const r = div.getBoundingClientRect();
                    const a = r.width * r.height;

                    if (a > area) {
                        area = a;
                        biggest = div;
                    }

                });

                if (biggest) {

                    biggest.style.display = "flex";
                    biggest.style.flexDirection = "column";
                    biggest.style.height = "100%";

                    const children = biggest.children;

                    if (children.length >= 3) {

                        children[1].style.flex = "1";
                        children[1].style.overflowY = "auto";

                        children[2].style.flexShrink = "0";
                    }
                }
            }

        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        return true;
    }

    let tries = 0;

    const timer = setInterval(() => {

        tries++;

        if (initInlineChat() || tries > 20) {
            clearInterval(timer);
        }

    }, 500);

});